module.exports = __webpack_public_path__ + "static/media/pantallasa.2ae82e97.jpg";